<script>
import OrderProgressBar from '@/components/cockpit/activeOrder/OrderProgressBar.vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'CockpitActiveOrderCard',
  props: {
    activeOrders: Array,
    selectedLabelingPointId: Number,
    disabled: Boolean,
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
  },
  components: {
    OrderProgressBar,
  },
  computed: {
    ...mapGetters([
      'globalSettings',
    ]),
    ...mapState({
      lines: state => state.lines.list || [],
      labelingPoints: state => state.labelingPoints.list || [],
    }),
    selectedLabelingPoint() {
      return this.labelingPoints
        .find(lp => lp.id === this.selectedLabelingPointId);
    },
    orderLineName() {
      return this.lines.find(l => l.id === this.orderDetails?.lineId)?.name || '';
    },
    orderLabelingPoints() {
      const labelingPoints = this.activeOrders.map(order => order.labelingPointId);
      return this.labelingPoints
        .filter(lp => labelingPoints.includes(lp.id))
        .map(lp => lp.name);
    },
    orderDetails() {
      return this.activeOrders[0]?.order || {};
    },
  },
  emits: [
    'select-order',
  ],
};
</script>

<template>
  <div
    class="cockpit-active-order-card"
    :class="{
      disabled,
    }"
  >
    <div class="active-order-heading d-flex justify-content-between">
      <div>
        <i class="fas fa-play-circle" />
        {{ $t('cockpit.activeOrder') }}
      </div>
    </div>

    <div
      v-if="false"
      class="line"
    />

    <div
      class="order-box"
      @click.stop="$emit('select-order', 1)"
    >
      <div class="order-info">
        <div class="order-number">
          {{ orderDetails.description }}
        </div>

        <div class="row order-info-columns">
          <div class="col-6 col-xl-4">
            <div>
              <span class="info-label">
                {{ $t('order.orderId') }}:
              </span>
              <span>
                {{ orderDetails.orderNumber }}
              </span>
            </div>
          </div>
          <div class="col-6 col-xl-4">
            <div>
              <span class="info-label">
                {{ $t('order.start') }}:
              </span>
              <span>
                {{ orderDetails.startDate | formatDate }}
              </span>
            </div>
          </div>
          <div class="col-12 col-xl-4">
            <div>
              <span class="info-label">
                {{ $t('order.sku') }}:
              </span>
              <span>
                {{ orderDetails.sku.name || orderDetails.sku.description }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="order-progress">
        <OrderProgressBar
          v-if="orderDetails.orderedQuantity"
          :value="orderDetails.done"
          :total="orderDetails.orderedQuantity"
          :unit="orderDetails.orderedUnit"
        />
      </div>

      <div
        v-if="selectedLabelingPointId && selectedLabelingPoint"
        class="order-line"
      >
        <div class="line-name">
          {{ orderLineName }}
        </div>
        /
        <div class="subline-name ml-2">
          {{ selectedLabelingPoint.name }}
        </div>
      </div>
      <div
        v-else
        class="order-line"
      >
        <div class="line-name">
          {{ orderLineName }}
        </div>
        /
        <div class="subline-name">
          <div class="labeling-points">
            <div
              v-for="orderLabelingPoint in orderLabelingPoints"
              :key="orderLabelingPoint"
            >
              {{ orderLabelingPoint }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cockpit-active-order-card {
  background-color: #FFFFFF;
  width: 100%;
  border-radius: 9px;
  padding: 16px;

  &.disabled {
    .order-box {
      cursor: default;

      &:hover {
        background-color: #FFFFFF;
      }
    }
  }

  .active-order-heading {
    font-size: 18px;
    font-weight: 500;
    //padding-bottom: 16px;

    i {
      margin-right: 8px;
    }
  }

  .line {
    border-bottom: 1px solid #F0F1F3;
  }

  .order-progress {
    width: 24%;
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .order-box {
    margin-top: 16px;
    padding: 16px 30px 16px 16px;
    border-radius: 6px;
    border: 1px solid #F0F1F3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: 0 1px 4px 0 #EEEFF0;

    &:hover {
      background-color: #f8f8f8;
    }

    .order-info {
      flex-grow: 1;
      .order-number {
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 6px;
      }

      .order-info-columns {
        font-size: 11px;
        color: #7E7E7E;

        .info-label {
          font-weight: 500;
        }
      }
    }
  }

  .order-line {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    font-size: 11px;
    font-weight: 400;
    color: #7E7E7E;

    .line-name {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 4px;
      margin-right: 5px;
      color: black;
    }

    .labeling-points {
      display: flex;
      gap: 2px;
      flex-direction: column;
      font-size: 10px;
      margin-left: 5px;
    }
  }
}
</style>
